import 'construct-style-sheets-polyfill';

function toObject(this: CSSStyleSheet) {
  return Array.from(this.cssRules).reduce((acc, rule) => {
    const [selector, pseudo] = (rule as CSSPageRule).selectorText.split(':');
    const css = (rule as CSSPageRule).style.cssText;
    if (pseudo) {
      acc[selector] = `${acc[selector] ?? ''}&:${pseudo}{${css}}`;
    } else {
      acc[selector] = `${acc[selector] ?? ''}${css}`;
    }
    return acc;
  },
  {} as Record<string, string>);
}

declare global {
  interface CSSStyleSheet {
    toObject: typeof toObject;
  }
}

Object.assign(CSSStyleSheet.prototype, { toObject });

export {};
